// Self-hosted fonts — Latin + Cyrillic (en, uk). JetBrains Mono stays Latin-only (code samples).
import "@fontsource/inter-tight/cyrillic-400.css";
import "@fontsource/inter-tight/cyrillic-500.css";
import "@fontsource/inter-tight/cyrillic-600.css";
import "@fontsource/inter-tight/cyrillic-700.css";
import "@fontsource/inter-tight/cyrillic-800.css";
import "@fontsource/inter-tight/latin-400.css";
import "@fontsource/inter-tight/latin-500.css";
import "@fontsource/inter-tight/latin-600.css";
import "@fontsource/inter-tight/latin-700.css";
import "@fontsource/inter-tight/latin-800.css";
import "@fontsource/inter/cyrillic-400.css";
import "@fontsource/inter/cyrillic-500.css";
import "@fontsource/inter/cyrillic-600.css";
import "@fontsource/inter/cyrillic-700.css";
import "@fontsource/inter/latin-400.css";
import "@fontsource/inter/latin-500.css";
import "@fontsource/inter/latin-600.css";
import "@fontsource/inter/latin-700.css";
import "@fontsource/jetbrains-mono/latin-400.css";
import "@fontsource/jetbrains-mono/latin-500.css";
import "@fontsource/jetbrains-mono/latin-600.css";
import "@styles/index.scss";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { i18n, i18nReady } from "@/i18n";
import { SUPPORTED_LANGUAGES } from "@/i18n/config";

import { App } from "./App";

const rootElement = document.getElementById("app");
if (!rootElement) throw new Error("Root element #app not found");

void i18nReady.then(() => {
  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>
  );

  // Preload other locales on idle so switching is instant — avoids
  // i18next suspense/remount which would break useReveal IntersectionObserver state.
  const preloadOthers = () => {
    const others = SUPPORTED_LANGUAGES.map((l) => l.code).filter(
      (c) => c !== i18n.resolvedLanguage
    );
    if (others.length) void i18n.loadLanguages(others);
  };
  if ("requestIdleCallback" in window) {
    (window as Window).requestIdleCallback(preloadOthers, { timeout: 2000 });
  } else {
    setTimeout(preloadOthers, 1500);
  }
});
